import { EmeshApiClient } from "@/typescript/api_client/emesh_api/client";
import { getBearerToken } from "@/typescript/lib/common/get_bearer_token";
import { download } from "@/typescript/lib/common/download";
import {
  GetAlertHistoryCsvParams,
  GetAlertHistoryCsvErrorResponse
} from "./types";

const emeshApiClient: EmeshApiClient = new EmeshApiClient(
  "/v1/alert_history/csv"
);

export async function getAlertHistoryCsvApi(params: GetAlertHistoryCsvParams) {
  return await emeshApiClient
    .get({
      params: params,
      headers: {
        Authorization: getBearerToken()
      },
      responseType: "blob"
    })
    .then(resp => {
      download(resp.data, "alert_history.csv");
    })
    .catch(e => {
      if (e.data) {
        return Promise.reject(e.data as GetAlertHistoryCsvErrorResponse);
      }
      return Promise.reject(e);
    });
}
